import { createFileRoute } from "@tanstack/react-router";

import Confirm from "./-components/Confirm";

export const Route = createFileRoute(
  "/_app/_dashboard/subscription/cancel/confirm"
)({
  component: Confirm,
});
